import React from "react";
import "./BlogStyles.css";
import "./ResponsiveBlog.css";
import { PostBlog } from "./PostBlog/PostBlog";

const APPLE_STORE_URL = "https://apps.apple.com/pl/app/sharecipe/id6470614602";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.sharecipe";

export const Blog = () => {
  return (
    <section className="blog">
      <div className="blogWrapper">
        <div className="topInfo">
          <h2>Scan QR Code to Download</h2>
          <p>
            Scan the dynamic QR code with your mobile camera to get the official ShareRecipe App on iOS or Android.
          </p>
        </div>

        <div className="postsWrapper">    
          <PostBlog
            qrUrl={APPLE_STORE_URL}
            storeUrl={APPLE_STORE_URL}
            storeType="apple"
            badgeTitle="iOS App Store"
            btnSub="Download on the"
            btnTitle="App Store"
          />

          <PostBlog
            qrUrl={GOOGLE_PLAY_URL}
            storeUrl={GOOGLE_PLAY_URL}
            storeType="google"
            badgeTitle="Google Play"
            btnSub="GET IT ON"
            btnTitle="Google Play"
          />
        </div>
      </div>
    </section>
  );
};
